var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackingIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1",
    clipPath: "url(#clip0_3_94273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#F7F3E3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.71002 12.1401V22.3701L15.68 26.9701",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.63 9.95996V17.26",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.42 16.34V12.14L16.56 7.03003L13.63 8.72003V14.98",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.6 19.6201L18.47 26.7501",
    stroke: "#09363F",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20.77 20.83C20.77 21.69 20.07 22.39 19.21 22.39C18.35 22.39 17.65 21.69 17.65 20.83C17.65 19.97 18.35 19.27 19.21 19.27C20.07 19.27 20.77 19.97 20.77 20.83Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M26.4 25.4101C26.4 26.2701 25.7 26.9701 24.84 26.9701C23.98 26.9701 23.28 26.2701 23.28 25.4101C23.28 24.5501 23.98 23.8501 24.84 23.8501C25.7 23.8501 26.4 24.5501 26.4 25.4101Z",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackingIcon3);
export default __webpack_public_path__ + "static/media/stacking_icon3.b10155fdd9a8d7b63894f5ae5236a38f.svg";
export { ForwardRef as ReactComponent };